import { ResourceAppModule } from "@/shared/app";
import { plmApp } from "../app";
import { Wyrob, wyrobResource } from "@megarax/client/src/resources/plm";

export const wyrobModule: ResourceAppModule = {
  formComponent: () => import("./ItemForm.vue"),
  sheetComponent: () => import("./ItemSheet.vue"),
  listComponent: () => import("./ItemList.vue"),
  iconClass: "fas fa-fill-drip fa-fw",
  route: "wyrob",
  title: "Wyroby",
  app: plmApp,
  itemConstructor: Wyrob,
  resource: wyrobResource,
};
